import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";
import { ConnectionUploadDialog } from "./ConnectionUploadDialog";

export function ConnectionSettings() {
    const [uploads, setUploads] = useState<any[]>([]);
    const [showUpload, setShowUpload] = useState(false);

    const loadUploads = async () => {
        const { data } = await supabase
            .from("connection_uploads")
            .select(
                "*, team_member:sales!connection_uploads_team_member_id_fkey(first_name, last_name)",
            )
            .order("uploaded_at", { ascending: false });
        if (data) setUploads(data);
    };

    useEffect(() => {
        loadUploads();
    }, []);

    return (
        <div className="mx-auto max-w-4xl p-6">
            <div className="mb-4 flex items-center justify-between">
                <h1 className="text-2xl font-bold">LinkedIn Connections</h1>
                <Button onClick={() => setShowUpload(true)}>
                    Upload Connections
                </Button>
            </div>
            <div className="rounded-md border">
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Team Member</TableHead>
                            <TableHead>Connections</TableHead>
                            <TableHead>Matched</TableHead>
                            <TableHead>Upload Date</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {uploads.map((u) => (
                            <TableRow key={u.id}>
                                <TableCell>
                                    {u.team_member?.first_name}{" "}
                                    {u.team_member?.last_name}
                                </TableCell>
                                <TableCell>{u.connection_count}</TableCell>
                                <TableCell>{u.matched_count}</TableCell>
                                <TableCell className="text-muted-foreground">
                                    {new Date(
                                        u.uploaded_at,
                                    ).toLocaleDateString()}
                                </TableCell>
                            </TableRow>
                        ))}
                        {uploads.length === 0 && (
                            <TableRow>
                                <TableCell
                                    colSpan={4}
                                    className="text-center text-muted-foreground"
                                >
                                    No uploads yet
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>
            {showUpload && (
                <ConnectionUploadDialog
                    onClose={() => setShowUpload(false)}
                    onComplete={() => {
                        setShowUpload(false);
                        loadUploads();
                    }}
                />
            )}
        </div>
    );
}
